<div [ngClass]="env !== 'PROD' ? 'component' : ''">
	<div class="logo">
		<img [title]="title" [alt]="title" class="imageclass" src="assets/images/logo.svg" width="90%">
	</div>
	<div class="app">
		<h2 class="title">{{ title }} <span *ngIf="env !== 'PROD'">[{{ env }}]</span></h2>
	</div>
	<div *ngIf="appSettings.user" class="user">
		<div class="welcome">
			Welcome<br />
			<span>{{ appSettings.user.name }}</span>
			<br />
			<span 
				(click)="toggleDropdown()" 
				class="clickable" 
			>
				{{ userRole }}
			</span>
			<img 
				*ngIf="isPowerUser" 
				height="12" 
				src="assets/images/caret_down.png" 
				(click)="toggleDropdown()" 
				class="settings-icon">
		</div>								
		<div *ngIf="isDropdownVisible" class="dropdown-menu" >
			<ul>
				<li *ngFor="let role of acceptedRoles" (click)="onOptionSelect(role)">
					{{role.toString().split('-')[1].trim()}}
				</li>
			</ul>
		</div>
		
		<div class="profile">
			<img *ngIf="showPhoto" [src]="appSettings.user.photo" (error)="showPhoto = false" height="100%" [alt]="appSettings.user.name">
			<div class="initials">{{ appSettings.user.initials }}</div>
		</div>
	</div>	
</div>
